/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import * as Platform from '../Platform';
import { ReachPlayer } from '../Reach/ReachPlayer';
import { ReachPlayerHardwareIdGeneratorMixin } from '../mixins/ReachPlayerHardwareIdGeneratorMixin';
import { isReachBasedScreenSaver } from './utility';

/* global REACH */

/**
 * @constructor
 * @augments ReachPlayer
 * @mixes ReachPlayerHardwareIdGeneratorMixin
 * @deprecated Will no longer be sold to clients
 */
function ScreenSaverPlayer() {
    ReachPlayer.call(this);
}

ScreenSaverPlayer.prototype = Object.create(ReachPlayer.prototype);
ReachPlayerHardwareIdGeneratorMixin.call(ScreenSaverPlayer.prototype);
ScreenSaverPlayer.prototype.constructor = ScreenSaverPlayer;

/**
 * @inheritDoc
 */
ScreenSaverPlayer.prototype.type = Platform.SCREEN_SAVER;

/**
 * @inheritDoc
 */
ScreenSaverPlayer.prototype.name = 'Screen Saver';

/**
 * @returns {boolean}
 */
ScreenSaverPlayer.isTheRunningPlatform = function () {
    const isLegacyScreenSaver = typeof REACH !== 'undefined' && REACH.ScreenSaver;
    const isReach = typeof REACH !== 'undefined' && typeof REACH.CEF !== 'undefined';
    const isScreenSaver = isReach && isReachBasedScreenSaver();
    return isLegacyScreenSaver || isScreenSaver;
};

export { ScreenSaverPlayer };
